import { useState, type ReactNode } from "react";

type Props = { phase: "loading" | "ready" | "error"; children: ReactNode };

/** Keep the controls mounted while the next drill scope is loading. */
export function ProductionAnalysisControls({ phase, children }: Props) {
  const [lastReady, setLastReady] = useState<ReactNode>(phase === "ready" ? children : null);
  if (phase === "ready" && lastReady !== children) setLastReady(children);
  return <div className="pa-fixed-controls" inert={phase !== "ready"} aria-busy={phase === "loading"}>
    {phase === "ready" ? children : lastReady}
  </div>;
}
